<template>
  <v-container class="mt-5 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="transparent elevation-0">
          <v-card-title primary-title class="text-subtitle-1">
            <v-spacer></v-spacer>
            <!-- ACTUALIZAR LA INFO -->
            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize( )"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
            
          </v-card-title>

          <!-- CONTENIDO -->
          <v-card-text class="">

            <!-- FILTROS  -->
            <v-row>
              <v-col cols="12" sm="4" lg="4" xl="3">
                
              </v-col>
            </v-row>

            <v-row align="center">

              <!-- DESGLOSE DE LOS PAGOS; SOLO PARA VENDEDORAS -->
              <v-col cols="12"class="pa-0">
                <v-card
							    class="shadowCard"
							    max-width="600"
							  >
							    <v-list-item two-line>
							      <v-list-item-content>
							        <v-list-item-title class="text-h5 align-center" align="center">
							        	<v-spacer></v-spacer>
							          Estado de Resultados
							        	<v-spacer></v-spacer>
							        </v-list-item-title>
							      </v-list-item-content>
							    </v-list-item>

                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title class="text-h5 align-center" align="center">
                        <v-spacer></v-spacer>
                        Nombre de la empresa
                        <v-spacer></v-spacer>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

							    <v-card-text>
							    	<v-row>
							    		<v-col cols="6">
							    			<v-text-field
							            v-model="fechainicial"
							            label="Fecha inicial"
							            prepend-icon="mdi-calendar"
							            filled
							            dense
							            hide-details
                        ></v-text-field>
							    		</v-col>
							    		<v-col cols="6">
							    			<v-text-field
							            v-model="fechafinal"
							            label="Fecha inicial"
							            prepend-icon="mdi-calendar"
							            filled
							            dense
							            hide-details
							          ></v-text-field>
							    		</v-col>
							    	</v-row>
							    </v-card-text>

							    <v-card-text class="white--text primary pa-2 align-center" align="center">
							    	DATOS GENERALES
							    </v-card-text>
							    
							    <v-list class="transparent" dense>
							      <v-list-item>
							        <v-list-item-title>Ingresos</v-list-item-title>

							        <v-list-item-subtitle class="text-right">
							          <v-chip color color="yellow" small @click="dialogIngresos = true">{{ formatMoney( ingresos ) }}</v-chip>
							        </v-list-item-subtitle>
							      </v-list-item>

                  </v-list>

                  <v-list class="transparent" dense color="yellow">
                    <v-list-item>
                      <v-list-item-title>Utilidad Bruta</v-list-item-title>

                      <v-list-item-subtitle class="text-right">
                        <v-chip color color="yellow" small @click="dialogIngresos = true">{{ formatMoney( 0 ) }}</v-chip>
                      </v-list-item-subtitle>
                    </v-list-item>

                  </v-list>

                  <div class="mt-6 ml-4"><b>Gastos de operación</b></div>

                  <v-list class="transparent" dense >
							      <v-list-item>
							        <v-list-item-title>Costos</v-list-item-title>

							        <v-list-item-subtitle class="text-right">
                        <v-chip color color="yellow" small @click="dialogEgresos = true">{{ formatMoney( costos ) }}</v-chip>
							        </v-list-item-subtitle>
							      </v-list-item>

                    <v-list-item>
                      <v-list-item-title>Gastos</v-list-item-title>

                      <v-list-item-subtitle class="text-right">
                        <v-chip color color="yellow" small @click="dialogEgresos = true">{{ formatMoney( gastos ) }}</v-chip>
                      </v-list-item-subtitle>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-title>Inversión</v-list-item-title>

                      <v-list-item-subtitle class="text-right">
                        <v-chip color color="yellow" small @click="dialogEgresos = true">{{ formatMoney( inversion ) }}</v-chip>
                      </v-list-item-subtitle>
                    </v-list-item>

							      <!-- <v-list-item>
							        <v-list-item-title>Margen</v-list-item-title>

							        <v-list-item-subtitle class="text-right">
							          {{ formatMoney( margen ) }}
							          <v-tooltip bottom color="blue">
										      <template v-slot:activator="{ on, attrs }">
										        <v-icon
										          color="blue"
										          dark
										          small
										          v-bind="attrs"
										          v-on="on"
										        >
										          mdi-information
										        </v-icon>
										      </template>
										      <span> {{ formatMoney( ingresos ) }} - {{ formatMoney( egresos ) }}  </span>
										    </v-tooltip>
							        </v-list-item-subtitle>
							      </v-list-item> -->
							    </v-list>

                  <v-list class="transparent" dense color="yellow">
                    <v-list-item>
                      <v-list-item-title>Total de gastos de operación</v-list-item-title>

                      <v-list-item-subtitle class="text-right">
                        <v-chip color color="yellow" small @click="dialogEgresos = true">{{ formatMoney( egresos ) }}</v-chip>
                      </v-list-item-subtitle>
                    </v-list-item>

                  </v-list>

                  <v-list class="transparent white--text" dense color="primary">
                    <v-list-item>
                      <v-list-item-title class="white--text">Utilidad de operación</v-list-item-title>

                      <v-list-item-subtitle class="text-right">
                        <v-chip color color="yellow" small @click="dialogEgresos = true">{{ formatMoney( egresos ) }}</v-chip>
                      </v-list-item-subtitle>
                    </v-list-item>

                  </v-list>

							    

							    <v-list class="transparent">
							      <v-list-item>
							        <v-list-item-title>Utilidad neta</v-list-item-title>

							        <v-list-item-subtitle class="text-right">
							          {{ rentabilidad }} %
							          <v-tooltip bottom color="blue">
										      <template v-slot:activator="{ on, attrs }">
										        <v-icon
										          color="blue"
										          dark
										          small
										          v-bind="attrs"
										          v-on="on"
										        >
										          mdi-information
										        </v-icon>
										      </template>
										      <span>(( {{ formatMoney( ingresos ) }} - {{ formatMoney( egresos ) }} ) / {{ formatMoney( ingresos ) }} ) * 100 </span>
										    </v-tooltip>
							        </v-list-item-subtitle>
							      </v-list-item>

							      <!-- <v-list-item>
							        <v-list-item-title>ROI</v-list-item-title>

							        <v-list-item-subtitle class="text-right">
							          {{ roi }} %
							          <v-tooltip bottom color="blue">
										      <template v-slot:activator="{ on, attrs }">
										        <v-icon
										          color="blue"
										          dark
										          small
										          v-bind="attrs"
										          v-on="on"
										        >
										          mdi-information
										        </v-icon>
										      </template>
										      <span>( ({{ formatMoney( margen ) }} / {{ formatMoney( egresos ) }} ) * 100 </span>
										    </v-tooltip>
							        </v-list-item-subtitle>
							      </v-list-item> -->
							    </v-list>

							    <v-divider></v-divider>

							    <v-card-actions>
							      <v-btn text @click="dialogReporteFull = true">
							        Reporte completo
							      </v-btn>
							    </v-card-actions>
							  </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- dialog para diferencias -->
    <v-dialog
      v-model="dialogIngresos"
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
      max-width="600"
    >
      <v-card>
        <v-card-title primary-title>
          Reporte de ingresos
          <v-spacer></v-spacer>
          <v-btn small dark tile color="green" @click="exportar(planteles)">
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>
        </v-card-title>
        <!-- Datos principales del usuario -->
        <v-card-text>

          <v-row>
            <v-col cols="12" class="black--text">
               <b>Total de ingresos:</b> {{ ingresosDesglose.length }}<br/>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headersIngresos"
            :items="ingresosDesglose"
            class="elevation-0 mt-4"
            dense
            mobile-breakpoint="200"
          >
          	<!-- Valores que ocupan botons, chips, iconos, etc -->
				    <template v-slot:item.monto="{ item }">
				      {{ formatMoney( item.monto ) }}
				    </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogIngresos = false" small tile  color="black" dark>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- dialog para diferencias -->
    <v-dialog
      v-model="dialogEgresos"
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
      max-width="600"
    >
      <v-card>
        <v-card-title primary-title>
          Reporte de egresos
          <v-spacer></v-spacer>
          <v-btn small dark tile color="green" @click="exportar(planteles)">
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>
        </v-card-title>
        <!-- Datos principales del usuario -->
        <v-card-text>

          <v-row>
            <v-col cols="12" class="black--text" v-if="plantel">
               <b>Total de egresos:</b> {{ egresosDesglose.length }}<br/>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headersIngresos"
            :items="egresosDesglose"
            class="elevation-0 mt-4"
            dense
            mobile-breakpoint="200"
          >
          	<!-- Valores que ocupan botons, chips, iconos, etc -->
				    <template v-slot:item.monto="{ item }">
				      {{ formatMoney( item.monto ) }}
				    </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogEgresos = false" small tile  color="black" dark>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo con reporte FULL de Datos -->
    <v-dialog
      v-model="dialogReporteFull"
      persistent
      transition="dialog-bottom-transition"
      max-width="800"
    >
      <v-card>
        <v-card-title primary-title>
          Reporte de egresos
          <v-spacer></v-spacer>
          <v-btn small dark tile color="green" @click="exportar(planteles)">
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>
        </v-card-title>
        <!-- Datos principales del usuario -->
        <v-card-text>
          <v-expansion-panels
            v-model="panel"
            multiple
          >
            <v-expansion-panel v-for="( reporte, i) in reporteFull" :key="i">
              <v-expansion-panel-header>{{ reporte.clasificacion }} <v-spacer></v-spacer> {{  reporte.monto }} </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table
                  :headers="headersIngresos"
                  :items="reporte.detalles"
                  class="elevation-0 mt-4"
                  dense
                  mobile-breakpoint="200"
                >
                	<!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.monto="{ item }">
							      {{ formatMoney( item.monto ) }}
							    </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogReporteFull = false" small tile  color="black" dark>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />

  </v-container>
</template>
<script>
import axios from 'axios';

import { mapGetters } from "vuex";
// Componentes
import Alerta from "@/components/alertas/Alerta.vue";
import carga  from "@/components/alertas/carga.vue";

import validarErrores           from "@/mixins/validarErrores";

var XLSX = require("xlsx");

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export default {
  components: {
    Alerta,
    carga,
  },

  mixins: [ validarErrores ],

  data: () => ({
    // Alertas
    parametros: {
      dialogError: false,
      mensaje: "",
      color: "",
    },

    respuestaAlerta: false,
    loader: true,
    cargar: false,

    
    fechainicial: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    fechafinal: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

    headersCifras: [
      { text: "Plantel"      , value: "plantel"       },
      { text: "ingreso"      , value: "ingreso"       },
      { text: "egreso"       , value: "egreso"        },
      { text: "margen"       , value: "margen"        },
      { text: "Rentabilidad" , value: "rentabilidad"  },
    ],

    ingresos: 0,
    egresos: 0,
    margen:0,
    margen_moneda:0,
    ciclo_ant:0,
    anio_ant: 0,
    rentabilidad: 0,
    roi: 0,
    ciclo_ant_i:0,
    ciclo_ant_e:0,
    anio_ant_i:0,
    anio_ant_e:0,

    dialogIngresos: false,
    dialogEgresos: false,

    headersIngresos:[
      { text: "ID"            , value: "idclasificacion" },
      { text: "Clasificación" , value: "clasificacion"   },
      { text: "Detalle"       , value: "detalle"         },
      { text: "Monto"         , value: "monto"           , align: 'end' },
    ],

    ingresosDesglose:[],

    headersEgresos:[
      { text: "idrequi"   , value: "id_requisicion_compra"  },
      { text: "Concepto"  , value: "concepto"               },
      { text: "Monto"     , value: "montototal"             },
      { text: "Plantel"   , value: "plantel_egresos"        },
    ],
    egresosDesglose:[],

    planteles:[],

    plantel: null,

    color:'',
    dialogReporteFull: false,

    reporteFull: [],
    panel:[],
    colorIngreso:'',
    costos:0,
    inversion:0,
    gastos:0,
  }),

  watch: {

  },

  computed: {
    ...mapGetters("login", ["getdatosUsuario"]),
  },

  async created() {
    await this.initialize( )

  },

  methods: {
    initialize() {
      this.cargar = true 

      var payload = {
        fechainicial: this.fechainicial,
        fechafinal  : this.fechafinal
      };

      this.$http.post("estado.resultados", payload).then((response) => {
        this.ingresos               = response.data.ingresos
        this.egresos                = response.data.egresos
        this.margen                 = response.data.margen
        this.rentabilidad           = response.data.rentabilidad
        this.roi                    = response.data.roi
        this.ingresosDesglose       = response.data.ingresosDesglose
        this.egresosDesglose        = response.data.egresosDesglose
        this.costosDesglose         = response.data.costosDesglose
        this.gastosDesglose         = response.data.gastosDesglose
        this.inversionDesglose      = response.data.inversionDesglose
        this.reporteFull            = response.data.reporteFull

        this.costos                 = response.data.costos
        this.inversion              = response.data.inversion
        this.gastos                 = response.data.gastos
        
        this.cargar       = false
      }).catch((error) => {
        this.validarError(error);
      }).finally(() => { this.cargar = false; });
    },


    getDiferenciaCiclos() {

      var payload = {
        id_ciclo: this.plantel.match('FAST') ?  this.ciclo.id_ciclo_relacionado :  this.ciclo.id_ciclo ,
      };

      this.cargar = true

      this.diferencias = []
      this.$http.post("inscripciones.comparaciones.ciclo", payload).then((response) => {
        this.cargar = false
        this.diferencias = response.data;
      }).catch((error) => {
        this.validarError(error);
      }).finally(() => { this.cargar = false; });
    },

    abrirDialog(value) {
      this.alumnos = value;
      this.dialogCifras = true;
    },

    exportar(value) {
      const alumnos = values.map(({ plantel, ingreso, egreso, rentabilidad }) => ({ plantel, ingreso, egreso, rentabilidad }));

      this.exportExcel(alumnos);
    },

    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },

    exportExcel(value) {
      let data = XLSX.utils.json_to_sheet(value);
      const workbook = XLSX.utils.book_new();
      const filename = "cifras_" + this.plantel;
      XLSX.utils.book_append_sheet(workbook, data, filename);

      var wbout = XLSX.write(workbook, {
        bookType: "xls",
        bookSST: false,
        type: "binary",
      });

      const file = new File([new Blob([this.s2ab(wbout)])], filename + ".xls");

      let formData = new FormData();
      // //se crea el objeto y se le agrega como un apendice el archivo
      formData.append("file", file);
      // /*getDatosRiesgo the form data*/

      this.$http
        .post("pdfs", formData)
        .then((response) => {
          window.location =
            axios.defaults.baseURL + "pdfs/" + filename + ".xls";
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },

    formatMoney(value) {
      // Formateamos el número como moneda en dólares (USD)
      return value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    },
  },
};
</script>